export default __webpack_public_path__ + "static/media/add.5965a941.svg";